export default __webpack_public_path__ + "static/media/kimchi_and_chips.0727af04.png";